import { Controller } from '@hotwired/stimulus';

export default class ChangeDistributorController extends Controller {
  static targets = ['select', 'submitButton'];

  connect() {
    this.toggleSubmitButton();
  }

  toggleSubmitButton() {
    this.submitButtonTarget.disabled = this.selectTarget.value === '';
  }
}
